function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import './styles/style.css';
import './styles/enter-button.css';
import './app.js';
import './fleet.js';
var mintbtn = document.getElementById("mintbtn");
var connectbtn = document.getElementById("connectbtn");

//connect to wallet
function connect() {
  return _connect.apply(this, arguments);
} //const audioNFTs = await displayAudioNFTs(UserAddress);
//const audioNFTsContainer = document.getElementById("audio-nfts");
//audioNFTsContainer.style.display = "block";
//let audioNFTsHTML = '';
//audioNFTs.forEach((audioNFT) => {
//audioNFTsHTML += `
//<div>
//<p class = "assettitle">CyberVerse  Audio NFT:</p><p class="assetdescription"> ${audioNFT.name}</p>
//</div>
//`;
//});
//audioNFTsContainer.innerHTML = audioNFTsHTML;
//}
//display cypx amount 
function _connect() {
  _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var ConnectUserWallet, currentDate, currentYear, currentMonth, currentDay, numDays, calendarHeader, calendarDiv, _loop, i, UserAddress, cypxAmount, _mintbtn, UserBalance, UserBalanceErg, dashboardbtn, assets, assetsHTML;
    return _regeneratorRuntime().wrap(function _callee6$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return ergoConnector.nautilus.connect();
        case 3:
          ConnectUserWallet = _context7.sent;
          ConnectUserWallet;

          // Get the current date
          currentDate = new Date();
          currentYear = currentDate.getFullYear();
          currentMonth = currentDate.getMonth();
          currentDay = currentDate.getDate(); // Get the number of days in the current month
          numDays = new Date(currentYear, currentMonth + 1, 0).getDate(); // Display the current month
          calendarHeader = document.createElement("h3");
          calendarHeader.style.display = "block";
          calendarHeader.setAttribute('id', 'calendarheader');
          calendarHeader.style.textAlign = "center";
          calendarHeader.textContent = new Date(currentYear, currentMonth, 1).toLocaleDateString('default', {
            month: 'long'
          });
          calendarDiv = document.getElementById("calendar");
          calendarDiv.style.display = "flex";
          calendarDiv.appendChild(calendarHeader);

          // Add input field for address search

          // Generate buttons for each day of the current month
          _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(i) {
            var button, buttonDate;
            return _regeneratorRuntime().wrap(function _loop$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  button = document.createElement("button");
                  button.textContent = i;
                  buttonDate = new Date(currentYear, currentMonth, i);
                  if (buttonDate > currentDate) {
                    button.style.display = "none";
                  }
                  button.addEventListener("click", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                    var requestDate, requestBody, response, data, datamodal;
                    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                      while (1) switch (_context5.prev = _context5.next) {
                        case 0:
                          requestDate = "".concat(currentMonth + 1, "/").concat(i, "/").concat(currentYear);
                          requestBody = {
                            "name": "barman",
                            "date": requestDate
                          };
                          _context5.next = 4;
                          return fetch("https://leaderboard-backend.herokuapp.com/api/leaderboard", {
                            method: "POST",
                            body: JSON.stringify(requestBody),
                            headers: {
                              "Content-Type": "application/json"
                            }
                          });
                        case 4:
                          response = _context5.sent;
                          _context5.next = 7;
                          return response.json();
                        case 7:
                          data = _context5.sent;
                          console.log(data);

                          // Loop through data and create new HTML elements for each object
                          datamodal = document.getElementById("datamodal");
                          datamodal.style.display = "block";
                          datamodal.innerHTML = "<h1> Data for ".concat(requestDate);
                          data.data.forEach(function (item) {
                            var points = item.points;
                            var address = item.address;
                            var itemElement = document.createElement("div");
                            itemElement.innerHTML = "<div class = \"cont5\"><p class = \"maintext\">Address:</p> <p class = \"subtext\"> ".concat(address, "</p><p class = \"maintext\">Points:</p> <p class = \"subtext\"> ").concat(points, "</p></div>");
                            datamodal.appendChild(itemElement);
                          });
                        case 13:
                        case "end":
                          return _context5.stop();
                      }
                    }, _callee5);
                  })));
                  calendarDiv.appendChild(button);
                case 6:
                case "end":
                  return _context6.stop();
              }
            }, _loop);
          });
          i = 1;
        case 20:
          if (!(i <= numDays)) {
            _context7.next = 25;
            break;
          }
          return _context7.delegateYield(_loop(i), "t0", 22);
        case 22:
          i++;
          _context7.next = 20;
          break;
        case 25:
          _context7.next = 27;
          return ergo.get_change_address();
        case 27:
          UserAddress = _context7.sent;
          _context7.next = 30;
          return displayCypxAmount(UserAddress);
        case 30:
          cypxAmount = _context7.sent;
          _mintbtn = document.getElementById("mintbtn");
          _context7.next = 34;
          return ergo.get_balance();
        case 34:
          UserBalance = _context7.sent;
          UserBalanceErg = UserBalance / Math.pow(10, 9);
          dashboardbtn = document.getElementById("dashboardbtn");
          dashboardbtn.style.display = "flex";
          connectbtn.style.display = "none";
          console.log(UserAddress);
          console.log(UserBalanceErg);
          document.getElementById("userbalance").style.display = "flex";
          document.getElementById("userbalance").innerHTML = "<img src=\"./dist/assets/ergicon.png\" id=\"balanceicon\">   " + UserBalanceErg;
          document.getElementById("cypxbalance").innerHTML = "<img src=\"./dist/assets/cypxicon.png\" id=\"cypxicon\">" + cypxAmount / Math.pow(10, 4);
          _context7.next = 46;
          return displayCybercitizenAssets(UserAddress);
        case 46:
          assets = _context7.sent;
          // if ergoConnector is not defined, show alert to download nautilus.
          assetsHTML = '';
          _context7.next = 53;
          break;
        case 50:
          _context7.prev = 50;
          _context7.t1 = _context7["catch"](0);
          if (_context7.t1.message.includes("ergoConnector")) {
            alert('Please download Nautilus wallet : https://chrome.google.com/webstore/detail/nautilus-wallet/gjlmehlldlphhljhpnlddaodbjjcchai');
          } else {
            alert("Error connecting to wallet: ".concat(_context7.t1));
          }
        case 53:
        case "end":
          return _context7.stop();
      }
    }, _callee6, null, [[0, 50]]);
  }));
  return _connect.apply(this, arguments);
}
function displayCypxAmount(_x) {
  return _displayCypxAmount.apply(this, arguments);
} //for audio nft viewing when it is implemented
function _displayCypxAmount() {
  _displayCypxAmount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(userAddress) {
    var response, data, cypxAmount;
    return _regeneratorRuntime().wrap(function _callee7$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return fetch("https://api.ergoplatform.com/api/v1/boxes/unspent/byAddress/".concat(userAddress));
        case 2:
          response = _context8.sent;
          _context8.next = 5;
          return response.json();
        case 5:
          data = _context8.sent;
          cypxAmount = 0; //look for asset names CYPX
          data.items.forEach(function (item) {
            item.assets.forEach(function (asset) {
              if (asset.name === "CYPX") {
                cypxAmount += asset.amount;
              }
            });
          });
          //log cypx amount and display on screen
          console.log("CYPX Amount: ".concat(cypxAmount));
          return _context8.abrupt("return", cypxAmount);
        case 10:
        case "end":
          return _context8.stop();
      }
    }, _callee7);
  }));
  return _displayCypxAmount.apply(this, arguments);
}
function formatTime(seconds) {
  var minutes = Math.floor(seconds / 60);
  var remainingSeconds = Math.floor(seconds % 60);
  return "".concat(minutes, ":").concat(remainingSeconds.toString().padStart(2, '0'));
}
//display cybercitizens in dashboard modal
function displayCybercitizenAssets(_x2) {
  return _displayCybercitizenAssets.apply(this, arguments);
} // DISPLAY AUDIO NFT FUNCTIONALITY AS WELL AS PLAYING AUDIO NFT FUNCTIONALITY, TO BE IMPLEMENTED
// async function displayAudioNFTs(userAddress) {
//   const response = await fetch(`https://api.ergoplatform.com/api/v1/boxes/unspent/byAddress/${userAddress}`);
//   const data = await response.json();
//   const audioNFTs = [];
//   data.items.forEach((item) => {
//     item.assets.forEach((asset) => {
//       if (['Laser Guns', 'Outrun', 'Danger Zone', 'Cyberlykos', 'Blue Lights', 'Into Cyberia'].includes(asset.name)) {
//         audioNFTs.push({
//           name: asset.name,
//         });
//       }
//     });
//   });
//   let audioNFTsHTML = '';
//   audioNFTs.forEach((audioNFT) => {
//     audioNFTsHTML += `
//       <div class="assetcont">
//         <p class="assettitle">CyberVerse Track Name:</p>
//         <p class="assetdescription">${audioNFT.name}</p>
//         <button class="play-button" data-asset="${audioNFT.name}">Play</button>
//         <button class="pause-button" data-asset="${audioNFT.name}" style="display:none;">Pause</button>
//         <div class="seek-container">
//           <input class="seek-bar" type="range" min="0" step="1" value="0">
//           <span class="current-time">0:00 </span><span>/</span>
//           <span class="duration">0:00</span>
//         </div>
//       </div>
//     `;
//   });
//   const audioNFTsElement = document.getElementById("audio-nfts");
//   audioNFTsElement.innerHTML = audioNFTsHTML;
//   // add event listeners to play buttons
//   const playButtons = document.querySelectorAll('.play-button');
//   playButtons.forEach(button => {
//     const assetName = button.dataset.asset;
//     const audio = new Audio(`./dist/assets/audio-dashboard/${assetName.replace(/ /g, '_')}.wav`);
//     let audioPlayer;
//     const seekBar = button.parentElement.querySelector('.seek-bar');
//     const currentTime = button.parentElement.querySelector('.current-time');
//     const duration = button.parentElement.querySelector('.duration');
//     audio.addEventListener('loadedmetadata', () => {
//       duration.textContent = formatTime(audio.duration);
//       seekBar.max = audio.duration;
//     });
//     seekBar.addEventListener('input', () => {
//       currentTime.textContent = formatTime(seekBar.value);
//       audio.currentTime = seekBar.value;
//     });
//     button.addEventListener('click', () => {
//       audio.play();
//       audioPlayer = audio;
//       button.style.display = 'none';
//       button.nextElementSibling.style.display = 'inline-block'; // show the pause button
//     });
//     // add event listeners to pause buttons
//     const pauseButtons = document.querySelectorAll('.pause-button');
//     pauseButtons.forEach(pauseButton => {
//       pauseButton.addEventListener('click', () => {
//         audioPlayer.pause();
//         pauseButton.style.display = 'none';
//         pauseButton.previousElementSibling.style.display = 'inline-block'; // show the play button
//       });
//     });
//     // update seek bar as audio plays
//     audio.addEventListener('timeupdate', () => {
//       seekBar.value = audio.currentTime;
//       currentTime.textContent = formatTime(audio.currentTime);
//     });
//     // add event listener to window to check if
// window.addEventListener('blur', () => {
// audioNFTs.forEach(audioNFT => {
// const audio = new Audio(`./dist/assets/audio-dashboard/${audioNFT.name.replace(/ /g, '_')}.wav`);
// let isPlaying = false;
// let duration = 0;
// let seekBar = null;
//   audio.addEventListener('play', () => {
//     isPlaying = true;
//     duration = audio.duration;
//     seekBar.max = duration;
//   });
//   audio.addEventListener('pause', () => {
//     isPlaying = false;
//   });
//   audio.addEventListener('timeupdate', () => {
//     if (isPlaying) {
//       seekBar.value = audio.currentTime;
//     }
//   });
//   const playButton = document.querySelector(`.play-button[data-asset="${audioNFT.name}"]`);
//   const pauseButton = document.querySelector(`.pause-button[data-asset="${audioNFT.name}"]`);
//   seekBar = document.querySelector(`.seek-bar[data-asset="${audioNFT.name}"]`);
//   playButton.addEventListener('click', () => {
//     audio.play();
//     isPlaying = true;
//     playButton.style.display = 'none';
//     pauseButton.style.display = 'inline-block';
//   });
//   pauseButton.addEventListener('click', () => {
//     audio.pause();
//     isPlaying = false;
//     pauseButton.style.display = 'none';
//     playButton.style.display = 'inline-block';
//   });
//   seekBar.addEventListener('input', () => {
//     audio.currentTime = seekBar.value;
//   });
// });
// });
// }
//)}
// display dashboard on click - showing ccs
function _displayCybercitizenAssets() {
  _displayCybercitizenAssets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(userAddress) {
    var response, data, _dashboard, cybercitizenAssets, assetsHTML, dashboard;
    return _regeneratorRuntime().wrap(function _callee8$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return fetch( // fetch cybercitizen assets by address
          "https://api.ergoplatform.com/api/v1/boxes/unspent/byAddress/".concat(userAddress));
        case 2:
          response = _context9.sent;
          _context9.next = 5;
          return response.json();
        case 5:
          data = _context9.sent;
          if (!(!data.items || data.items.length === 0)) {
            _context9.next = 11;
            break;
          }
          _dashboard = document.getElementById("dashboard");
          _dashboard.style.backgroundColor = "transparent";
          _dashboard.innerHTML = "\n          <div style=\"text-align: center; margin-top:5rem\">\n            <p style = \"color:var(--yellow)\"> You have no CyberCitizens :(</p>\n            <p style=\"color:var(--pink)\">Check out <a href=\"https://www.skyharbor.io/collection/cybercitizens\" target=\"_blank\">SkyHarbor</a> to grab some!</p>\n          </div>\n        ";
          return _context9.abrupt("return", []);
        case 11:
          cybercitizenAssets = []; // look for any assets named "Cybercitizen" and take the number after it and save as assetNum, use assetnum in image path to display correct image
          data.items.forEach(function (item) {
            item.assets.forEach(function (asset) {
              if (asset.name.includes("Cybercitizen")) {
                var assetNum = asset.name.match(/#(\d+)/)[1];
                cybercitizenAssets.push({
                  name: asset.name,
                  tokenId: asset.tokenId,
                  amount: asset.amount,
                  imgSrc: "./dist/pages/gen2/assets/cc-images/".concat(assetNum, ".png"),
                  imgSrcingame: "./dist/pages/gen2/assets/in-game/".concat(assetNum, ".png")
                });
              }
            });
          });
          // render assets into modal
          assetsHTML = "";
          cybercitizenAssets.forEach(function (asset) {
            assetsHTML += "\n          <div class=\"assetcont\">\n            <p class=\"assettitle\"></p> <p class=\"assetdescription\">".concat(asset.name, "</p>\n            <p class=\"assettitle\">Token ID:</p> <p class=\"assetdescription\"> ").concat(asset.tokenId, "</p>\n            <img class=\"ccimage\" src=\"").concat(asset.imgSrc, "\" />\n            <img class=\"ccimage\" src=\"").concat(asset.imgSrcingame, "\" />\n          </div>\n        ");
          });
          dashboard = document.getElementById("dashboard");
          dashboard.innerHTML += assetsHTML;
          return _context9.abrupt("return", cybercitizenAssets);
        case 18:
        case "end":
          return _context9.stop();
      }
    }, _callee8);
  }));
  return _displayCybercitizenAssets.apply(this, arguments);
}
var displaybtn = document.getElementById("dashboardbtn");
displaybtn.addEventListener("click", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        dashboardmodal.style.display = "block";
        // close dashboard on click
      case 1:
      case "end":
        return _context.stop();
    }
  }, _callee);
})));
var closebtn = document.getElementById("closedashboard");
closebtn.addEventListener("click", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        dashboardmodal.style.display = "none";
      case 1:
      case "end":
        return _context2.stop();
    }
  }, _callee2);
})));
document.getElementById("copyme").addEventListener("click", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var textToCopy;
  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        textToCopy = document.getElementById("copyme").textContent;
        _context3.prev = 1;
        _context3.next = 4;
        return navigator.clipboard.writeText(textToCopy);
      case 4:
        alert("Text copied to clipboard!");
        _context3.next = 10;
        break;
      case 7:
        _context3.prev = 7;
        _context3.t0 = _context3["catch"](1);
        console.error("Failed to copy text: ", _context3.t0);
      case 10:
      case "end":
        return _context3.stop();
    }
  }, _callee3, null, [[1, 7]]);
})));

// connect to wallet on click connect btn

connectbtn.addEventListener("click", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        connect();
        connectbtn.classList.add("disabled");
        connectbtn.disabled = true;
      case 3:
      case "end":
        return _context4.stop();
    }
  }, _callee4);
})));
var datamodal = document.getElementById("datamodal");

// Hide the modal when the user clicks outside of it
window.addEventListener("click", function (event) {
  datamodal.style.display = "none";
});